import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOpt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconOpt"><Path fillRule="evenodd" clipRule="evenodd" d="M3 4H8.44278L16.4428 18.5H21V20H15.5572L7.55722 5.5H3V4ZM15 4H21V5.5H15V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOpt;
